import React, { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const navLinks = [{
  name: '首页',
  sub: 'Home',
  href: '#hero'
}, {
  name: '关于',
  sub: 'About',
  href: '#about'
}, {
  name: '伴游',
  sub: 'Companions',
  href: '#categories'
}, {
  name: '服务',
  sub: 'Services',
  href: '#services'
}, {
  name: '联系',
  sub: 'Contact',
  href: '#contact'
}];
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-dark-900/90 backdrop-blur-md py-4 shadow-lg border-b border-white/5' : 'bg-transparent py-6'}`} data-id="element-252">
      <div className="max-w-7xl mx-auto px-6 flex justify-between items-center" data-id="element-253">
        {/* Logo */}
        <a href="#" className="group" data-id="element-254">
          <div className="text-2xl font-serif font-bold tracking-widest text-white group-hover:text-gold-200 transition-colors duration-300" data-id="element-255">
            TT<span className="text-gold-500" data-id="element-256">vip</span>
          </div>
          <div className="text-[10px] tracking-[0.3em] text-gold-500/80 uppercase" data-id="element-257">
            Singapore
          </div>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center space-x-12" data-id="element-258">
          {navLinks.map(link => <a key={link.name} href={link.href} className="group flex flex-col items-center" data-id="element-259">
              <span className="text-sm font-medium text-gray-300 group-hover:text-gold-400 transition-colors duration-300" data-id="element-260">
                {link.name}
              </span>
              <span className="text-[10px] text-gray-600 group-hover:text-gold-500/70 transition-colors duration-300 uppercase tracking-wider mt-0.5" data-id="element-261">
                {link.sub}
              </span>
            </a>)}
          <button className="px-6 py-2 border border-gold-500/30 text-gold-400 text-xs tracking-widest hover:bg-gold-500 hover:text-dark-900 transition-all duration-300 uppercase" data-id="element-262">
            VIP Access
          </button>
        </div>

        {/* Mobile Menu Button */}
        <button className="md:hidden text-white hover:text-gold-500 transition-colors" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-263">
          {isMobileMenuOpen ? <X size={24} data-id="element-264" /> : <Menu size={24} data-id="element-265" />}
        </button>
      </div>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-266">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} className="absolute top-full left-0 right-0 bg-dark-900 border-b border-white/10 md:hidden" data-id="element-267">
            <div className="flex flex-col p-6 space-y-6" data-id="element-268">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="flex items-center justify-between group border-b border-white/5 pb-4 last:border-0" data-id="element-269">
                  <span className="text-lg text-white group-hover:text-gold-400 transition-colors" data-id="element-270">
                    {link.name}
                  </span>
                  <span className="text-xs text-gray-500 uppercase tracking-widest group-hover:text-gold-500/70" data-id="element-271">
                    {link.sub}
                  </span>
                </a>)}
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}